import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

import api from "assets/services/api";


function ModalAddSellsman(props) {

    const [br, setBR] = useState(false);

    const [contact, setContact] = useState(null);
    const [name, setName] = useState("");
    const [lastname, setLastname] = useState("");
    const [address, setAddress] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState();
    const { storageId } = useAuth();
    const [controlSnack, setControlSnack] = useState(false);

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                        props.onHide();
                    }, 2000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) { showNotification("br") }
    }, [controlSnack]);


    async function handleAddSellsman(e) {
        e.preventDefault();
        const response = await api.post('/sellsman', {
            contact,
            id_admin: storageId,
            username,
            password,
            name,
            lastname,
            address
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        props.getAllSellsman();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar vendedor
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddSellsman}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridUsername">
                            <Form.Label>Usuário</Form.Label>
                            <Form.Control onChange={event => setUsername(event.target.value)} type="text" placeholder="Usuário do login" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPassword">
                            <Form.Label>Senha</Form.Label>
                            <Form.Control onChange={event => setPassword(event.target.value)} type="password" placeholder="Senha do vendedor" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control onChange={event => setName(event.target.value)} type="text" placeholder="Nome do vendedor" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridLastname">
                            <Form.Label>Sobrenome</Form.Label>
                            <Form.Control onChange={event => setLastname(event.target.value)} type="text" placeholder="Sobrenome do vendedor" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>Contato</Form.Label>
                            <PhoneInput
                                defaultCountry="BR"
                                className="form-control"
                                placeholder="Contato do vendedor"
                                value={contact}
                                onChange={setContact} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>Endereço</Form.Label>
                            <Form.Control onChange={event => setAddress(event.target.value)} type="text" placeholder="Endereço do vendedor" />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Adicionar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Vendedor adicionado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalAddSellsman;